export default [
  {
    params: {
      path: '/app/chat',
      name: 'Chat',
    },
    defaultComponentPath: 'Applications/Chat/Chat',
    navs: true,
  },
  {
    params: {
      path: '/app/contacts',
      name: 'Contacts',
    },
    defaultComponentPath: 'Applications/Contacts/Contacts',
    navs: true,
  },
  {
    params: {
      path: '/app/imagelabeling',
      name: 'ImageLabeling',
    },
    defaultComponentPath: 'Applications/ImageLabeling/ImageLabeling',
    navs: true,
  },
]
